import React from 'react';
import { Badge } from '@chakra-ui/react';
import PropTypes from 'prop-types';

/**
 * Componente Badge reutilizable para filtros de estado/sub-estado
 * 
 * @param {string} colorScheme - Color del badge (Chakra UI color scheme)
 * @param {boolean} isActive - Si el filtro está activo
 * @param {function} onClick - Función a ejecutar al hacer click
 * @param {string} label - Texto a mostrar en el badge
 * @param {string} className - Clase CSS adicional (opcional)
 */
const FilterBadge = ({ 
  colorScheme, 
  isActive, 
  onClick, 
  label,
  className = ''
}) => {
  return (
    <Badge 
      colorScheme={colorScheme} 
      className={`filter-badge ${isActive ? 'filter-badge-active' : 'filter-badge-inactive'} ${className}`}
      onClick={onClick}
    >
      {label}
    </Badge>
  );
};

FilterBadge.propTypes = {
  colorScheme: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default FilterBadge;
